"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = [
    '11-9050',
    '11-9071',
    '11-9170',
    '11-9171',
    '11-9199.08',
    '13-2022',
    '17-1022',
    '17-2071',
    '17-2170',
    '17-2199.10',
    '17-3029.08',
    '19-2041.02',
    '19-4012',
    '19-4030',
    '19-4044',
    '21-1021',
    '25-1042',
    '25-2050',
    '27-1000',
    '27-1023',
    '27-1026',
    '27-2021',
    '27-2042',
    '27-3010',
    '29-1030',
    '29-1040',
    '29-1080',
    '29-1126',
    '29-1129.02',
    '29-1130',
    '29-1141.01',
    '29-1170',
    '29-1217',
    '29-2032',
    '29-2051',
    '29-2055',
    '29-2060',
    '29-9093',
    '31-1120',
    '31-1131',
    '31-1132',
    '31-9010',
    '31-9091',
    '31-9092',
    '31-9095',
    '31-9096',
    '31-9097',
    '33-1091',
    '33-3012',
    '33-3030',
    '33-3050',
    '33-9032',
    '33-9091',
    '33-9092',
    '33-9094',
    '35-1011',
    '35-2000',
    '35-2010',
    '35-2012',
    '35-2013',
    '35-2020',
    '35-3000',
    '35-3010',
    '35-3020',
    '35-3030',
    '35-3040',
    '35-9010',
    '35-9020',
    '37-2010',
    '37-2011',
    '37-2020',
    '37-3000',
    '37-3011',
    '37-3013',
    '39-2020',
    '39-4020',
    '39-5010',
    '39-5011',
    '39-5012',
    '39-5091',
    '39-5092',
    '39-6011',
    '39-9010',
    '39-9031',
    '41-2000',
    '43-3070',
    '43-4080',
    '43-4120',
    '43-4150',
    '43-4170',
    '43-5011.01',
    '43-5020',
    '43-5051',
    '43-5053',
    '45-0000',
    '45-2000',
    '45-2020',
    '45-2040',
    '45-2092',
    '47-2010',
    '47-2022',
    '47-2030',
    '47-2041',
    '47-2042',
    '47-2044',
    '47-2060',
    '47-2070',
    '47-2081',
    '47-2110',
    '47-2140',
    '47-2141',
    '47-2151',
    '47-2152',
    '47-2160',
    '47-2180',
    '47-2210',
    '47-2220',
    '47-3000',
    '47-3012',
    '47-4010',
    '47-4030',
    '47-4040',
    '47-4050',
    '47-4070',
    '47-4099.03',
    '47-5011',
    '47-5040',
    '47-5070',
    '49-3000',
    '49-3020',
    '49-3021',
    '49-3022',
    '49-3023',
    '49-3030',
    '49-3040',
    '49-3041',
    '49-3043',
    '49-3091',
    '49-3093',
    '49-9011',
    '49-9020',
    '49-9030',
    '49-9041',
    '49-9043',
    '49-9044',
    '49-9050',
    '49-9070',
    '49-9080',
    '49-9092',
    '49-9094',
    '49-9096',
    '49-9099.01',
    '51-2040',
    '51-2050',
    '51-3010',
    '51-3021',
    '51-3023',
    '51-3093',
    '51-4040',
    '51-4120',
    '51-4121',
    '51-5100',
    '51-5112',
    '51-6010',
    '51-6030',
    '51-6051',
    '51-6092',
    '51-7000',
    '51-7020',
    '51-8030',
    '51-9071.06',
    '51-9083',
    '51-9110',
    '51-9120',
    '51-9194',
    '51-9195.04',
    '51-9197',
    '51-9198',
    '53-1041',
    '53-2000',
    '53-2012',
    '53-2030',
    '53-3031',
    '53-3032',
    '53-3033',
    '53-3050',
    '53-3051',
    '53-3052',
    '53-3053',
    '53-3054',
    '53-4030',
    '53-5000',
    '53-5010',
    '53-5022',
    '53-5030',
    '53-6000',
    '53-6020',
    '53-6030',
    '53-6031',
    '53-7000',
    '53-7040',
    '53-7050',
    '53-7060',
    '53-7061',
    '53-7064',
    '53-7071',
    '53-7073',
    '53-7120',
    '53-7190',
    '55-0000',
    '55-1017',
    '55-3011',
    '55-3012',
    '55-3016',
    '55-3018',
];
